import angular from 'angular';
import moment from 'moment';

class Business {
  /* @ngInject */
  constructor($log, $rootScope, $http, $interval, $injector, Endpoints, Utils, API_URL) {
    Object.assign(this, {
      $log,
      $http,
      $rootScope,
      $interval,
      Endpoints,
      Utils,
      API_URL
    });
  }

  getFrontendParameters() {
    return this.$http.get(this.Endpoints.content.frontendParameters);
  }

  getAvailableStates() {
    return this.$http.get(this.Endpoints.business.availableStates);
  }

  getAllStates() {
    return this.$http.get(this.Endpoints.business.allStates);
  }

  getAllRoles() {
    // console.log(this.Endpoints.business.getAllRoles);
    // console.log(this)
    // this.roles = this.Users.ROLES
    // return Promise.resolve({ data: Users });
    return this.$http.get(this.Endpoints.business.getAllRoles);
  }

  getSummary() {
    return this.$http.get(`${this.API_URL}/admin/summary/?type[]=banner&type[]=funnel&polling=true`);
  }

  getRefreshSummary() {
    return this.$http.get('${this.API_URL}/admin/summary/?type[]=banner&type[]=funnel&polling=true&force_refresh=true');
  }

  getStatus() {
    return this.$http.get(this.Endpoints.meta.base);
  }

  getPlatformStatusToRefreshSession() {
    return this.$http.get(this.Endpoints.meta.status);
  }

  getPlatformStatus() {
    return this.$http.get(this.Endpoints.meta.status).then(results => {
      const statuses = results.data;

      _.each(statuses, (status, device) => {
        statuses[device] = this.Utils.strToBool(status);
      });

      return statuses;
    });
  }

  getPlatformConfig(platform) {
    return this.$http.get(`${this.Endpoints.meta.base}?platform=${platform}`);
  }

  updatePlatformStatus(platform, status, reason) {
    return this.$http.put(this.Endpoints.meta.status + platform, {
      status: this.Utils.humanizeBool(status),
      reason
    });
  }

  updateConfig(id, value) {
    return this.$http.put(this.Endpoints.meta.base + id, {
      value
    }, {
      loadingText: 'Updating Configuration'
    });
  }

  getSchedule() {
    return this.$http.get(`${this.Endpoints.business.hours}?polling=true`);
  }

  getSlvSchedule() {
    return this.$http.get(`${this.Endpoints.business.slvhours}&polling=true`);
  }

  getSlvOpen() {
    return this.$http.get(`${this.Endpoints.business.slvOpen}&polling=true`);
  }

  updateSchedule(schedule) {
    return this.$http.put(this.Endpoints.business.hours, schedule, {
      loadingText: 'Updating Office Hours'
    });
  }

  getHolidays() {
    return this.$http.get(`${this.API_URL}/admin/business/holidays?polling=true`);
  } // {
  //   "title": "MLK Day",
  //   "holiday": "YYYY-MM-DD"
  // }


  addHoliday({
    title,
    holiday
  }) {
    return this.$http.post(this.Endpoints.business.holidays, {
      title,
      holiday
    }, {
      loadingText: 'Adding Holiday'
    });
  }

  removeHoliday(holiday) {
    return this.$http.delete(`${this.Endpoints.business.holidays}/${holiday.business_holiday_id}`, {
      loadingText: 'Removing Holiday'
    });
  }

  isTodayAHoliday() {
    return this.getHolidays().then(({
      data
    }) => {
      for (let i = 0; i < data.length; i++) {
        if (moment(data[i].holiday).isSame(moment(), 'day')) {
          return true;
        }
      }

      return false;
    });
  }

  getSLVSchedules() {
    return this.$http.get(`${this.API_URL}/admin/slv/schedules`);
  }

  updateSLVSchedule(state_code, payload) {
    return this.$http.put(`${this.API_URL}/admin/slv/schedules/${state_code}`, payload);
  }

  getSchedules(schedule_code) {
    return this.$http.get(`${this.API_URL}/admin/schedules/${schedule_code}/bookings/settings`);
  }

  updateCallBooking(id, payload, schedule_code) {
    return this.$http.put(`${this.API_URL}/admin/schedules/${schedule_code}/bookings/settings/${id}`, payload);
  }

}

Business.$inject = ["$log", "$rootScope", "$http", "$interval", "$injector", "Endpoints", "Utils", "API_URL"];
angular.module('pims').service('Business', Business);